// Müşteriler, sözleşmeler, duyurular (C38–C41, C46–C48): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const CustomerList = load(() => import('./customers/CustomerList'), 'CustomerList');
const CustomerDetail = load(() => import('./customers/CustomerDetail'), 'CustomerDetail');
const CustomerForm = load(() => import('./customers/CustomerForm'), 'CustomerForm');
const ContractDetail = load(() => import('./customers/ContractDetail'), 'ContractDetail');
const AnnouncementCenter = load(() => import('./comms/AnnouncementCenter'), 'AnnouncementCenter');
const AnnouncementCompose = load(() => import('./comms/AnnouncementCompose'), 'AnnouncementCompose');
const AnnouncementHistory = load(() => import('./comms/AnnouncementHistory'), 'AnnouncementHistory');

export const businessRoutes = (
  <>
    <Route path="musteriler" element={guard(CustomerList, 'customers')} />
    <Route path="musteriler/yeni" element={guard(CustomerForm, 'customers', { action: 'edit' })} />
    <Route path="musteriler/:id" element={guard(CustomerDetail, 'customers')} />
    <Route path="sozlesmeler/:id" element={guard(ContractDetail, 'customers')} />
    <Route path="duyurular" element={guard(AnnouncementCenter, 'announcements')} />
    <Route path="duyurular/yeni" element={guard(AnnouncementCompose, 'announcements', { action: 'edit' })} />
    <Route path="duyurular/gecmis" element={guard(AnnouncementHistory, 'announcements')} />
    <Route path="duyurular/:id/duzenle" element={guard(AnnouncementCompose, 'announcements', { action: 'edit' })} />
  </>
);
